// extracted by css-extract-rspack-plugin
export default {"container":"fUgNN3onTsa9VlXp","label":"CHFHxIZfHEYrFfD4","helperText":"Z3gFXzWIyklZVPIR","promptBox":"Y9ZwAVDJ_oQJGEFY","promptText":"HKvHtg4EsA0zCYJC"};